<template>
  <section id="APP">
    <banner v-if="$route.name == 'main'"></banner>
    <gnb-area></gnb-area>
    <router-view></router-view>
    <footer-area></footer-area>
    <vue-confirm-dialog></vue-confirm-dialog>
  </section>
</template>
<script>
import Banner from './components/banner.vue';
import GnbArea from './html/layout/GnbArea.vue';
import FooterArea from './html/layout/FooterArea.vue';

export default {
  components: {
    Banner,
    GnbArea,
    FooterArea,
  },
};
</script>
<style></style>
